import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import './common/Global'
import './common/Directives'
import VModal from 'vue-js-modal'
import Toasted from 'vue-toasted'
import VueClipboard from 'vue-clipboard2'
import VeeValidate, { Validator } from 'vee-validate'
import validators from './common/Validations'
import VCalendar from 'v-calendar'
import 'vue-material-design-icons/styles.css'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import TextareaAutosize from 'vue-textarea-autosize'
import BaseMixins from '@/common/BaseMixins'
import resize from 'vue-element-resize-detector'
import ToggleButton from 'vue-js-toggle-button'
import Tawk from 'vue-tawk'
import StripePlugin from './plugins/stripe'
Vue.config.productionTip = false
/**
 * In this module root Vue instance is created and plugins are added
 */
/* validator plugin setup */
const validationDictionary = {
  en: {
    messages: {
      required: () => 'Required Field',
      email: () => 'Enter Valid Email'
    }
  }
}
Validator.localize(validationDictionary)
Validator.extend('emails', validators.emailListValidator)
/* add VeeValidate plugin */
Vue.use(VeeValidate, {
  events: 'blur'
})
/* add modal plugin */
Vue.use(VModal)
/* add element resize handler */
Vue.use(resize)
/* add simple toogler */
Vue.use(ToggleButton)
Vue.use(TextareaAutosize)
/* add toast plugin */
// Vue.use(Toasted, {
//   iconPack: 'fontawesome' // variants: material|fontawesome|custom-class
// })
/* add clipboard plugin */
Vue.use(VueClipboard)
/* add chat plugin */
Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/5f3c9910cc6a6a5947acecb6/default'
})

/* add calendar plugin */
Vue.use(VCalendar)

/* add stripe plugin */
Vue.use(StripePlugin, {
  // publicKey: 'pk_test_51RrMd7FD4e9wbrRzySLgdYQCMVvGRKLdnUMN5wTQAzAMK84aF9mJUvK9SvI89xHPpzb48V94ZCEh8nFYMRfLVHM400jgiKWKhO',
  publicKey: 'pk_live_51LTWSRF2icZGO8n1OksWobyCMVOXFLn1P8BPgOQF4OjH2lKGb40H030YYpNm21oPLQy7vskmJf5ZMb33Q5u2oTtn00D8Id1PDr',
  scriptSrc: 'https://js.stripe.com/v3/'
});

/* add tooltip directives */
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
/* add BaseMixins that is available in all components */
Vue.mixin(BaseMixins)
/* new Vue instance */
const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/* export created Vue instance to have access to router outside of components */
export default vue
